module.exports = __webpack_public_path__ + "assets/arrow-long-left.d49a23b1.svg";